import RatingsSecretScreen from "./RatingsSecretScreen";

export default RatingsSecretScreen;
